import { apiDelete, apiGet, apiPost, apiPut } from './api-service';
import { getUserDetails } from './session-service';

export async function getAll() {
    try {
        const response = await apiGet('core', `chemical`);
        return response;
    } catch (e) { }
}

export async function getChemical(id?: string) {
    try {
        const response = await apiGet('core', `chemical/${id}`);
        return response.content;
    } catch (e) {
        return {};
    }
}


export async function addChemical(newDetails: any) {
    try {
        const response = await apiPost('core', `chemical`, newDetails);
        return response;
    } catch (e) { }
}

export async function updateChemical(newDetails: any, id?: string) {
    try {
        if (!id) {
            id = getUserDetails().client_id;
        }
        const response = await apiPut('core', `chemical/${id}`, newDetails);

        return response.content;
    } catch (e) { }
}

export async function removeChemical(id: any) {
    try {

        return await apiDelete('core', `chemical/${id}`);
    } catch (e) { }
}

export async function duplicateChemical(id?: string) {
    try {
        const response = await apiGet('core', `chemical-duplicate/${id}`);
        return response.content;
    } catch (e) {
        return {};
    }
}